import React, { Component } from 'react';

import Error from './error';
import LoadingAnimation from '@/shared/components/LoadingAnimation';

function withFetching(WrappedComponent, { responseType } = {}) {
  return class WithFetching extends Component {
    constructor(props) {
      super(props);
      this.state = {};
      this.xhr = this.createRequest(props.filePath);
    }

    componentDidMount() {
      try {
        this.fetch();
      } catch (e) {
        const { onError } = this.props;
        if (onError) {
          onError(e);
        }
        this.setState({ error: 'fetch error' });
      }
    }

    componentWillUnmount() {
      this.abort();
    }

    render() {
      if (!this.xhr) {
        return <h1>CORS not supported..</h1>;
      }
      const { error, data } = this.state;

      if (error) {
        return <Error {...this.props} error={error} />;
      }

      if (data) {
        return <WrappedComponent data={data} {...this.props} />;
      }
      return <LoadingAnimation />;
    }

    createRequest(path) {
      let xhr = new XMLHttpRequest();

      if ('withCredentials' in xhr) {
        // XHR for Chrome/Firefox/Opera/Safari.
        xhr.open('GET', path, true);
      } else if (typeof XDomainRequest !== 'undefined') {
        // XDomainRequest for IE.
        xhr = new XDomainRequest();
        xhr.open('GET', path);
      } else {
        // CORS not supported.
        xhr = null;
        return null;
      }
      if (responseType) {
        xhr.responseType = responseType;
      }

      xhr.onload = () => {
        if (xhr.status >= 400) {
          this.setState({ error: `fetch error with status ${xhr.status}` });
          return;
        }
        const resp = responseType ? xhr.response : xhr.responseText;

        this.setState({ data: resp });
      };

      return xhr;
    }

    fetch() {
      this.xhr.send();
    }

    abort() {
      if (this.xhr) {
        this.xhr.abort();
      }
    }
  };
}

export default withFetching;
